import { useEffect, useMemo, useState } from 'react';

import { getWorksViews } from 'js/liswp/work_overview/api';

export function useWorkViews(
  workIds: number[],
  enabled: boolean,
): Record<string, number> {
  const [views, setViews] = useState<Record<string, number>>({});

  const ids = useMemo(
    () => (enabled ? workIds.filter((id) => id != null) : []),
    // eslint-disable-next-line react-hooks/exhaustive-deps -- keyed on the id list below
    [enabled, workIds.join(',')],
  );
  const idsKey = ids.join(',');

  useEffect(() => {
    if (!ids.length) return;

    getWorksViews(ids)
      .then((response) => setViews(response.views))
      .catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps -- keyed on the id list
  }, [idsKey]);

  return views;
}

export default useWorkViews;
